import { createFileRoute } from "@tanstack/react-router";
import { ParametresPanel } from "@/components/qorum/ParametresPanel";
import { socialMeta } from "@/lib/seo-meta";

export const Route = createFileRoute("/compte/parametres")({
  head: () => ({
    meta: [{ title: "Paramètres — Hōjin" }, { name: "robots", content: "noindex, nofollow" },
      ...socialMeta({
        title: "Paramètres — Hōjin",
        description: "Paramètres — Hōjin",
        url: "https://hojin.ai/compte/parametres",
        image: "secretaire",
        card: "summary_large_image",
      }),
    ],
    links: [{ rel: "canonical", href: "https://hojin.ai/compte/parametres" }],
  }),
  component: () => <ParametresPanel />,
});
